<template>
  <div
    class="rounded-lg border-l-4 border-amber-400 bg-amber-50 p-4 text-sm text-amber-800"
  >
    <slot />
  </div>
</template>
